export default __webpack_public_path__ + "static/media/cashback.041bec8f.svg";